module.exports = __webpack_public_path__ + "officialStatic/img/soft25.0d66e9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft25.png
// module id = +RsV
// module chunks = 0